'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var baseX = require('../../vendor/base-x.js');
var bytes = require('../bytes.js');
var base = require('./base.js');

const implement = alphabet => {
  const {encode, decode} = baseX(alphabet);
  return {
    encode,
    decode: text => bytes.coerce(decode(text))
  };
};
const base58btc = base.from({
  name: 'base58btc',
  prefix: 'z',
  ...implement('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz')
});
const base58flickr = base.from({
  name: 'base58flickr',
  prefix: 'Z',
  ...implement('123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ')
});

exports.base58btc = base58btc;
exports.base58flickr = base58flickr;
